export const commonPlaylist = [
  "Saved Videos",
  "Liked Videos",
  "My Notes",
  "My Playlist",
];
export const playlistNamesNotShowInAddTo = ["Liked Videos", "My Notes"];
